module.exports = "<h3>Top Heroes</h3>\n<div class=\"grid grid-pad\">\n  <a *ngFor=\"let hero of heroes\" class=\"col-1-4\" routerLink=\"/detail:{{hero.id}}\">\n    <div class=\"module hero\">\n      <h4>{{hero.name}}</h4>\n    </div>\n  </a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = ./src/app/dashboard/dashboard.component.html
// module chunks = main